/* tslint:disable */

/**
 */
export class TempRecordPts {
    AXIS2_AX_1?: number;
    ID_TEMP_RECORD_PTS?: number;
    AXIS1_PT_TOP_SURF?: number;
    AXIS2_PT_TOP_SURF?: number;
    AXIS3_PT_TOP_SURF?: number;
    AXIS1_PT_INT_PT?: number;
    AXIS2_PT_INT_PT?: number;
    AXIS3_PT_INT_PT?: number;
    AXIS1_PT_BOT_SURF?: number;
    AXIS2_PT_BOT_SURF?: number;
    AXIS3_PT_BOT_SURF?: number;
    ID_STUDY?: number;
    AXIS3_AX_1?: number;
    AXIS1_AX_2?: number;
    AXIS3_AX_2?: number;
    AXIS1_AX_3?: number;
    AXIS2_AX_3?: number;
    AXIS1_PL_2_3?: number;
    AXIS2_PL_1_3?: number;
    AXIS3_PL_1_2?: number;
    NB_STEPS?: number;
    CONTOUR2D_TEMP_MIN?: number;
    CONTOUR2D_TEMP_MAX?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/temp-record-pts.ts